import Handsontable from 'handsontable';
import uniq from 'lodash/uniq';
import moment from 'moment/moment';
import PropTypes from 'prop-types';
import React from 'react';

import { getRegistration } from '../services/api/registrations';
import { defaultDayFormater } from './utils';

export async function buildGridForRegistration(pRegistration, admin = false) {
  let registration = await getRegistration(pRegistration.id, {
    include: 'registration-profiles,registration-profiles.profile,event,event.periods,crew-quantity-requests',
  });

  let columns = [];
  let colHeaders = [];
  let rowHeaders = [];
  let data = [];

  // COLUMNS
  registration.registrationProfiles.forEach((regProfile) => {
    const name = 'regProfile_' + regProfile.id;
    columns.push({
      data: name,
      type: 'numeric',
      renderer: function (instance, td, row, col, prop, value, cellProperties) {
        Handsontable.renderers.NumericRenderer.apply(this, arguments);

        if (data[row][name + '_old']) {
          if (data[row][name + '_old'] !== value) {
            td.style.color = '#F00';
            td.style.fontWeight = 'bold';
          }
        }

        console.log(row, col, value, name);

        return td;
      },
    });

    colHeaders.push(regProfile.profile.name);
    if (registration.crewQuantityRequests.length > 1 && admin) {
      columns.push({
        data: 'regProfile_' + regProfile.id + '_old',
        type: 'numeric',
        readOnly: true,
      });
      colHeaders.push('← previous');
    }
  });

  // ROWS

  const eventDays = getEventDatesFromPeriods(registration.event.periods);
  eventDays.forEach((day) => {
    rowHeaders.push(defaultDayFormater(day));

    let row = {
      day,
    };

    registration.registrationProfiles.forEach((regProfile) => {
      const limit = regProfile.amountPerDay ? regProfile.amountPerDay.filter((profile) => profile.day === day) : [];
      row['regProfile_' + regProfile.id] = limit.length > 0 ? limit[0].amount : 0;

      if (registration.crewQuantityRequests.length > 1 && admin) {
        const previousAmounts = registration.crewQuantityRequests[registration.crewQuantityRequests.length - 2];
        const previousForProfile = previousAmounts.registrationProfiles.find((profile) => profile.id === regProfile.id);
        const oldlimit = previousForProfile?.amountPerDay
          ? previousForProfile.amountPerDay.filter((profile) => profile.day === day)
          : [];
        row['regProfile_' + regProfile.id + '_old'] = oldlimit.length > 0 ? oldlimit[0].amount : 0;
      }
    });

    data.push(row);
  });

  return {
    columns,
    colHeaders,
    rowHeaders,
    data,
    registration,
  };
}

export function getEventDatesFromPeriods(periods) {
  let eventDays = [];

  periods.forEach((period) => {
    if (period.type !== 'buildbreak') {
      let periodStart = moment(period.startsAt);
      const periodEnd = moment(period.endsAt);

      while (periodStart.diff(periodEnd) < 0) {
        eventDays.push(periodStart.clone());
        periodStart.add(1, 'day');
      }
    }
  });

  return uniq(eventDays.sort((a, b) => a - b).map((day) => day.format('YYYY-MM-DD')));
}

// Custom Formatter component
export class disabledCellFormater extends React.Component {
  static propTypes = {
    value: PropTypes.string,
  };

  render() {
    return <div style={{ opacity: '0.5' }}>{this.props.value}</div>;
  }
}
